module.exports = __webpack_public_path__ + "img/pigs.3f7207a6.png";